import { Injectable } from '@angular/core';
import { Client } from '@microsoft/microsoft-graph-client';

import { AuthService } from '../auth.service';
// import { Event } from './event';
// import { AlertsService } from './alerts.service';

@Injectable()
export class GraphService {

    private graphClient: Client;
    constructor(private authService: AuthService) {

        // Initialize the Graph client
        this.graphClient = Client.init({
            authProvider: (done) => {
                // Get the token from the auth service
                const token = localStorage.getItem('accessToken'); // await this.authService.getToken();
                    // .catch((reason) => {
                    //     done(reason, null);
                    // });

                // console.log('graph service token', token);
                if (token) {
                    done(null, token);
                } else {
                    done('Could not get an access token', null);
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./client/app/core/auth/graph/graph.service.ts